<template>
  <v-container>
    <v-layout raw wrap align-center class="my-5">
      <v-flex xs12 sm12 md6>
        <v-flex xs12 sm12 md6>
          <img src="../assets/jockey.jpg" alt="happiness" />
        </v-flex>
      </v-flex>
      <v-flex xs12 sm12 md6>
        <div class="text-xs-center">
          <h1 class="headline">The best way to start happiness</h1>
          <span class="subheading">
            Cras facilisis mi vitae nunc
          </span>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>
<style></style>